var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix), (_vm.cssPrefix + "--" + _vm.theme),
    ( _obj = {}, _obj[(_vm.cssPrefix + "--collapsed")] = _vm.collapsed, _obj ),
    'sw-flexbox', 'sw-flexbox--center-items' ]},[_c('sw-icon',{class:[(_vm.cssPrefix + "__arrow"), 'sw-flexbox__flex-none'],attrs:{"name":"arrow-up","size":10,"rotate":-90}}),_vm._v(" "),_c('sw-icon',{class:['sw-flexbox__flex-none'],attrs:{"name":"menu","size":16}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }